<template>
  <div class="xiyou-keyword-rank">
    <div class="header-box">
      <div class="header-line">
        <span class="header-label">投放状态</span>
        <el-select placeholder="匹配类型" size="small" v-model="params.type">
          <el-option label="父商品" value="parent"></el-option>
          <el-option label="子商品" value="child"></el-option>
        </el-select>
        <span class="header-label">产品类型</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productType" filterable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
        </el-select>

        <template v-if="params.type == 'child'">
          <span class="header-label">颜色</span>
          <el-select placeholder="产品类型" size="small" v-model="params.productColor">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
          </el-select>
          <span class="header-label">型号</span>
          <el-select placeholder="型号" size="small" v-model="params.model">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
          </el-select>
        </template>

        <el-button type="primary" size="small" @click="getProducts">查询</el-button>
        <el-button type="primary" size="small" @click="batchAddKeywords">一键新增</el-button>
      </div>
    </div>
    <el-table :data="keywordRanks" border size="small" :height="screenHeight" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"> </el-table-column>
      <el-table-column label="序号" width="45px">
        <template slot-scope="scope">
          {{ params.beginIndex + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="productName" label="产品名称" width="120px"> </el-table-column>
      <template v-if="this.params.type == 'child'">
        <el-table-column prop="productColorName" label="颜色" width="100px" sortable>
          <template slot-scope="scope">
            {{ scope.row.productColorName != "" ? scope.row.productColorName : scope.row.productColor }}
          </template>
        </el-table-column>
        <el-table-column prop="model" label="型号" width="100px" sortable> </el-table-column>
      </template>

      <el-table-column prop="keyword" label="关键词" width="240px" sortable> </el-table-column>
      <el-table-column prop="isDelivery" label="是否投放" width="80px" sortable>
        <template slot-scope="scope">
          <el-button v-if="scope.row.isDelivery == 0" type="text" size="small" @click="addKeyword(scope.row)">新增</el-button>
          <span v-else>{{ scope.row.isDelivery == 1 ? "已投放" : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="traffic" label="流量" width="80px" sortable align="right"> </el-table-column>
      <el-table-column prop="trafficProportion" label="流量占比" width="80px" sortable align="right">
        <template slot-scope="scope">
          {{ (scope.row.trafficProportion * 100).toFixed(2) + "%" }}
        </template>
      </el-table-column>
      <el-table-column prop="searchVolume" label="周搜索量" width="80px" sortable align="right"> </el-table-column>
      <el-table-column prop="keywordRank" label="关键词排名" width="80px" sortable align="right"> </el-table-column>
      <el-table-column prop="organicTrafficProportion" label="流量分布(自然)" width="80px" sortable align="right">
        <template slot-scope="scope">
          {{ (scope.row.organicTrafficProportion * 100).toFixed(2) + "%" }}
        </template>
      </el-table-column>
      <el-table-column prop="advertTrafficProportion" label="流量分布(广告)" width="80px" sortable align="right">
        <template slot-scope="scope">
          {{ (scope.row.advertTrafficProportion * 100).toFixed(2) + "%" }}
        </template>
      </el-table-column>
      <el-table-column prop="organicRank" label="自然排名" width="80px" sortable align="right"> </el-table-column>
      <el-table-column prop="organicRankPagePosition" label="自然排名(页码-页内排名)" width="80px" sortable> </el-table-column>
      <el-table-column prop="spAdvertRank" label="SP广告排名" width="80px" sortable align="right"> </el-table-column>
      <el-table-column prop="spAdvertRankPagePosition" label="SP广告排名(页码-页内排名)" width="80px" sortable> </el-table-column>
      <el-table-column prop="competitionDifficultyLevel" label="竞争难度档位" width="80px" sortable align="right"> </el-table-column>
      <el-table-column prop="competitionDifficulty" label="竞争难度" width="80px" sortable align="right"> </el-table-column>
      <el-table-column prop="displayPosition" label="展示位置" width="120px" sortable> </el-table-column>
      <el-table-column prop="relateAsinLabel0" label="相关变体1" width="170px" sortable> </el-table-column>
      <el-table-column prop="relateAsinLabel1" label="相关变体2" width="170px" sortable> </el-table-column>
      <el-table-column prop="relateAsinLabel2" label="相关变体3" width="170px" sortable> </el-table-column>
      <el-table-column prop="relateAsinLabel3" label="相关变体4" width="170px" sortable> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope"> </template>
      </el-table-column>
    </el-table>
    <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"> </el-pagination>

    <el-dialog title="新增关键词" :visible.sync="dialogFormVisible" width="25%">
      <el-form ref="form" label-width="80px">
        <el-form-item label="新增方式">
          <el-radio-group v-model="addType">
            <el-radio :label="1">相关变体</el-radio>
            <el-radio :label="2">选择商品</el-radio>
            <el-radio :label="3">手动输入</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="关键词">
          <span>{{ addKeywordParams.keywords[0] }}</span>
        </el-form-item>
        <el-form-item v-if="addType == 1" label="Asin">
          <el-select placeholder="请选择Asin" size="small" v-model="addKeywordParams.asin" style="width: 300px">
            <el-option v-for="item in asinsTrafficProportion" :key="item.asin" :value="item.asin" :label="item.asin + '-' + item.productColor + '-' + item.model + '-' + (item.percent * 100).toFixed(2) + '%'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addType == 3" label="Asin">
          <el-input type="text" placeholder="请输入" v-model="addKeywordParams.asin"> </el-input>
        </el-form-item>
        <template v-if="addType == 2">
          <el-form-item label="产品类型">
            <el-select placeholder="产品类型" size="small" v-model="addProductType">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="颜色">
            <el-select placeholder="产品类型" size="small" v-model="addProductColor">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="型号">
            <el-select placeholder="型号" size="small" v-model="addProductModel">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="匹配类型">
          <span>精准匹配</span>
        </el-form-item>
        <el-form-item label="投放价格">
          <span>{{ addKeywordParams.recommandBid }} </span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAddKeyword">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { colors, iPhoneModels, products, activeProducts, models } from "../../utils/constant.js";
export default {
  data() {
    return {
      screenHeight: document.body.clientHeight - 64 - 54 - 68 - 20,
      total: 0,
      pageCount: 1,
      totalPage: 1,
      checkAll: false,
      isIndeterminate: true,
      colors: colors,
      models: [],
      iPhoneModels: iPhoneModels,
      productLists: products,
      productList: activeProducts,
      colorList: colors,
      modelList: models,
      keywordRanks: [],
      selectedKeywordRanks: [],
      dialogFormVisible: false,

      addProductType: "",
      addProductColor: "",
      addProductModel: "",
      params: {
        beginIndex: 0,
        pageSize: 100,
        isDelivery: "",
        productType: "",
        type: "parent",
        productColor: "",
        model: "",
      },
      addKeywordParams: {
        asin: "",
        matchType: 1,
        recommandBid: 0.3,
        keywords: [],
      },
      asinsTrafficProportion: [],
      addType: 1,
      products: [],
    };
  },
  mounted() {
    // this.fetchKeywordRanks();
    this.getProducts();

    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 54 - 68;
      // console.log("calculateHeight", this.screenHeight);
    },
    handleSelectionChange(val) {
      this.selectedKeywordRanks = val;
    },
    getProducts() {
      if (this.params.type == "child" && this.params.productType > 0 && (this.params.productColor != "" || this.params.model != "")) {
        requestModules.fetchProducts({ productType: this.params.productType, productColor: this.params.productColor, model: this.params.model, beginIndex: 0, pageSize: 1000 }).then(res => {
          this.products = res.ldata;
          if (this.products.length == 1) {
            this.params.asinList = JSON.stringify([this.products[0].asin, ...this.products[0].competitorAsins]);
          } else {
          }
          this.fetchKeywordRanks();
        });
      } else {
        this.products = [];
        this.params.asinList = [];
        this.fetchKeywordRanks();
      }
    },
    addKeyword(row) {
      this.asinsTrafficProportion = row.asinsTrafficProportion;
      this.addKeywordParams.keywords = [row.keyword];
      this.addKeywordParams.asin = this.asinsTrafficProportion[0].asin;
      this.addKeywordParams.addProductType = "";
      this.addKeywordParams.addProductColor = "";
      this.addKeywordParams.addProductModel = "";
      this.dialogFormVisible = true;
      this.addType = 1;
    },
    submitAddKeyword() {
      let params = {
        asin: this.addKeywordParams.asin,
        matchType: this.addKeywordParams.matchType,
        recommandBid: this.addKeywordParams.recommandBid,
        productType: this.addProductType,
        productColor: this.addProductColor,
        productModel: this.addProductModel.replace(/\s/g, ""),
        keywords: JSON.stringify(this.addKeywordParams.keywords),
      };
      requestModules.addManualKeywordAdvert(params).then(res => {
        console.log(res);
        this.fetchKeywordRanks();
      });
      this.dialogFormVisible = false;
      console.log(this.addKeywordParams);
    },
    batchAddKeywords() {
      if (this.selectedKeywordRanks.length == 0) {
        this.$message({
          type: "error",
          message: "请选择关键词!",
        });
        return;
      }
      let unDeliveryKeywords = this.selectedKeywordRanks.filter(kr => kr.isDelivery == 0);
      let asinSet = new Set([]);
      let asinList = [];
      unDeliveryKeywords.forEach(dk => {
        let asinsTrafficProportion = dk.asinsTrafficProportion;
        asinsTrafficProportion.sort((a, b) => b.percent - a.percent);

        let asin = asinsTrafficProportion[0].asin;
        if (dk.productType == -1) {
          asin = this.products[0].asin;
        }
        asinSet.add(asin);
        asinList.push({ asin: asin, keyword: dk.keyword });
      });
      if (this.products.length != 1) {
        let asins = [...asinSet];
        for (let i = 0; i < asins.length; i++) {
          let list = asinList.filter(item => item.asin == asins[i]);
          let keywords = [];
          list.forEach(item => keywords.push(item.keyword));

          let params = {
            asin: asins[i],
            matchType: this.addKeywordParams.matchType,
            recommandBid: this.addKeywordParams.recommandBid,
            keywords: JSON.stringify(keywords),
          };
          console.log(params);
          requestModules.addManualKeywordAdvert(params).then(res => {
            console.log(res);
          });
        }
      } else {
        let keywords = [];
        asinList.forEach(item => keywords.push(item.keyword));

        let params = {
          asin: this.products[0].asin,
          matchType: this.addKeywordParams.matchType,
          recommandBid: this.addKeywordParams.recommandBid,
          keywords: JSON.stringify(keywords),
        };
        console.log(params);
        requestModules.addManualKeywordAdvert(params).then(res => {
          console.log(res);
        });
      }
    },
    fetchKeywordRanks() {
      if (this.params.type == "parent") {
        this.params.productColor = "";
        this.params.model = "";
      }
      requestModules
        .fetchKeywordRanks(this.params)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "获取列表失败",
            });
            return;
          }

          this.keywordRanks = res.ldata;
          this.total = res.total;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误",
          });
        });
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.fetchKeywordRanks();
    },
    getRelateAsinLabel(asinsTrafficProportion, index) {
      if (!asinsTrafficProportion || asinsTrafficProportion.length < index + 1) {
        return "";
      }
      asinsTrafficProportion.sort((a, b) => b.percent - a.percent);
      return asinsTrafficProportion[index].productColor + "-" + asinsTrafficProportion[index].model + "-" + (asinsTrafficProportion[index].percent * 100).toFixed(2) + "%";
    },
  },
};
</script>

<style lang="scss">
.no-padding {
  padding: 0px !important;
  .cell {
    padding: 0px !important;
  }
}
.form-line {
  .form-label {
    margin: 5px 10px 5px 0px;
    width: 80px;
    text-align: right;
    display: inline-block;
    span {
      color: red;
    }
  }
  .form-input {
    width: 800px;
    margin: 5px 0px;
    vertical-align: top;
  }
  .form-group {
    width: 700px;
    margin: 5px 0px;
    display: inline-block;
    vertical-align: top;

    .el-checkbox {
      width: 70px;
    }
    .el-radio {
      width: 70px;
    }
  }

  .color-box {
    width: 700px;
    margin: 5px 0px;
    display: inline-block;
    vertical-align: top;

    .color-item {
      display: inline-block;
      width: 80px;
      cursor: pointer;
      color: #409eff;
    }
  }
}
</style>
